import { render, staticRenderFns } from "./Biological.vue?vue&type=template&id=f74a535e&scoped=true"
import script from "./Biological.vue?vue&type=script&lang=js"
export * from "./Biological.vue?vue&type=script&lang=js"
import style0 from "./Biological.vue?vue&type=style&index=0&id=f74a535e&prod&lang=scss"
import style1 from "./Biological.vue?vue&type=style&index=1&id=f74a535e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74a535e",
  null
  
)

export default component.exports